import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { CmsFormPanel, PanelContent, PanelHeader, PanelTitle, PanelTrigger } from '@/components/shared/CmsFormPanel';
import { Plus } from 'lucide-react';
import { ConfirmDialog } from '@/components/shared';
import type { RaceSeries, SeriesFormData } from './raceseriesmanager.props';

interface RaceSeriesFormDialogProps {
  isDialogOpen: boolean;
  setIsDialogOpen: (open: boolean) => void;
  editingSeries: RaceSeries | null;
  formData: SeriesFormData;
  setFormData: (data: SeriesFormData) => void;
  openCreate: () => void;
  handleSubmit: (e: React.FormEvent) => void;
  deleteTarget: any;
  setDeleteTarget: (target: any) => void;
  confirmDelete: () => void;
}

const RaceSeriesFormDialog: React.FC<RaceSeriesFormDialogProps> = ({
  isDialogOpen, setIsDialogOpen, editingSeries, formData, setFormData,
  openCreate, handleSubmit, deleteTarget, setDeleteTarget, confirmDelete,
}) => (
  <>
    <CmsFormPanel open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <PanelTrigger asChild>
        <Button onClick={openCreate}>
          <Plus className="w-4 h-4 mr-2" />
          Нова серија
        </Button>
      </PanelTrigger>
      <PanelContent>
        <PanelHeader>
          <PanelTitle>{editingSeries ? 'Уреди серија' : 'Нова серија'}</PanelTitle>
        </PanelHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="name">Име *</Label>
            <Input id="name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required placeholder="пр. DrimRun" />
          </div>
          <div>
            <Label htmlFor="description">Опис</Label>
            <textarea
              id="description"
              className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm min-h-[80px]"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              placeholder="Опис на серијата..."
            />
          </div>
          <div>
            <Label htmlFor="imageUrl">Слика URL</Label>
            <Input id="imageUrl" value={formData.imageUrl} onChange={(e) => setFormData({ ...formData, imageUrl: e.target.value })} placeholder="https://..." />
          </div>
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={() => setIsDialogOpen(false)}>Откажи</Button>
            <Button type="submit">{editingSeries ? 'Зачувај' : 'Креирај'}</Button>
          </div>
        </form>
      </PanelContent>
    </CmsFormPanel>
    <ConfirmDialog
      open={deleteTarget !== null}
      onOpenChange={(open) => !open && setDeleteTarget(null)}
      title="Избриши серија"
      description="Дали сте сигурни дека сакате да ја избришете оваа серија?"
      onConfirm={confirmDelete}
    />
  </>
);

export default RaceSeriesFormDialog;
